import React, { useState } from "react";
import { useParams } from "react-router-dom";
import eventData from "../data/eventData";
import { X } from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function EventImages() {
    const { t } = useTranslation();
    const { id } = useParams();
    const [selectedImage, setSelectedImage] = useState(null);

    const event = eventData.find((event) => event.id === id);

    if (!event) {
        return <div>{t("Event not found")}</div>;
    }

    const { images } = event;

    return (
        <>
            <section className="landingPages">
                <div className="container h-[70vh] flex flex-col justify-center gap-[10px]">
                    <div className="btmAni2000 text-[40px] font-bold text-white capitalize">{t("Events Images")}</div>
                    <div className="btmAni25002 flex items-center gap-[5px] text-white">
                        <Link className="text-white" to={"/"}>{t("Home")}</Link>
                        -
                        <div className="text-[#016E82]">{t("Events Images")}</div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container">
                    <div className="flex flex-wrap gap-[20px]">
                        {images.map((image, index) => (
                            <div key={index} className="w-100 w-[22%] h-[250px] relative">
                                <img
                                    src={image}
                                    alt={`Event ${event.title} - ${index + 1}`}
                                    className="w-full h-full object-cover cursor-pointer rounded-lg shadow-lg hover:scale-105 transition duration-300"
                                    onClick={() => setSelectedImage(image)}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {selectedImage && (
                    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 backdrop-blur-md">
                        <div className="relative p-4">
                            <button
                                className="d-none absolute top-[2rem] right-[2rem] text-white bg-black bg-opacity-50 p-2 rounded-full hover:bg-opacity-80 transition"
                                onClick={() => setSelectedImage(null)}
                            >
                                <X size={28} />
                            </button>
                            <div className="w-100 w-[500px] h-[500px] flex items-center justify-center">
                                <img
                                    src={selectedImage}
                                    alt="Full Size"
                                    className="object-contain w-full h-full rounded-lg shadow-lg transition-opacity duration-300"
                                />
                            </div>
                            {/* Close Button for Mobile */}
                            <button
                                className="mt-4 px-6 py-2 bg-[#016E82] text-white rounded-lg block sm:hidden" // Hide on larger screens (sm:hidden)
                                onClick={() => setSelectedImage(null)}
                            >
                                {t("Close")}
                            </button>
                        </div>
                    </div>
                )}
            </section>
        </>
    );
}
